import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

import SessionConditions from "../../components/SessionConditions/SessionConditions";
import TableTop from "../../components/TableTop/TableTop";

import { getSession } from "../../store/Session/SessionService";
import { RootState, useAppDispatch } from "../../store/store";

import CombineScoreSection from "../../components/CombineScore/CombineScore";
import CombineSummaryWrap from "../../components/CombineSummaryChart/CombineSummaryWrap";
import SessionLocation from "../../components/SessionConditions/SessionLocation";
import ShotDispersionChartWrap from "../../components/ShotDispersionChart/ShotDispersionChartWrap";
import TargetTables from "../../components/TargetTables/TargetTables";
import "./style.css";
import ClubTables from "../../components/ClubTables/ClubTables";
import Spinner from "../../components/Spinner/Spinner";

const SessionSharing: React.FC = () => {
  const [tabSelected, setSelectedTab]: [
    "ball-data" | "club-data" | "key-data",
    any
  ] = React.useState("key-data");
  const { shareUrl } = useParams();

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    if (shareUrl && shareUrl.length) dispatch(getSession(shareUrl));
  }, [dispatch, shareUrl]);

  const sessionData = useSelector((state: RootState) => state.session);

  if (sessionData.status === "failed") {
    console.log("::Failed::");
    navigate("/not-found");
    return <></>;
  } else {
    return (
      <div className="session-sharing" id="session-sharing">
        <div className="session-info">
          <SessionLocation sessionData={sessionData} />
          <div className="wrap-session-info">
            <SessionConditions sessionData={sessionData} />
            <CombineScoreSection sessionData={sessionData} />
            <CombineSummaryWrap sessionData={sessionData} />
            <ShotDispersionChartWrap sessionData={sessionData} />
          </div>
        </div>
        <div className="session-data">
          {/* KWSA-42: both the column order and the club-vs-target split depend
              on data that has not arrived yet, so the whole section spins. */}
          {sessionData.status !== "success" ? (
            <Spinner minHeight={400} />
          ) : (
            <>
              <TableTop
                tabSelected={tabSelected}
                setSelectedTabFunc={setSelectedTab}
                sessionData={sessionData}
              />
              {sessionData.drillTargets &&
              sessionData.drillTargets?.length > 0 ? (
                <TargetTables
                  tabSelected={tabSelected}
                  sessionData={sessionData}
                />
              ) : (
                <ClubTables tabSelected={tabSelected} sessionData={sessionData} />
              )}
            </>
          )}
        </div>
      </div>
    );
  }
};

export default SessionSharing;
